import SlsPicItemClient from '@/api/Operacoes/sls-pic-item.client';

import { ErrorMessage } from '@/libs/Error';

export default class SLSPicItemService {
  constructor() {
    this.client = new SlsPicItemClient();
    this.error = new ErrorMessage();
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar as PicItem');
    }
  }

  async store(data) {
    try {
      return await this.client.store(data);
    } catch (error) {
      this.error.message(error, 'Erro ao criar PicItem');
    }
  }

  async show(id) {
    try {
      const { data } = await this.client.show(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar PicItem');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.client.update(id, data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar PicItem');
    }
  }

  async destroy(body) {
    try {
      const { data: response } = await this.client.destroy(body);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar PicItem');
    }
  }
}
